import React from 'react';
import Navbar from '../components/layout/navbar/Navbar';
import Footer from '../components/layout/footer/Footer';
import EducationGreeting from '../components/layout/education/EducationGreeting';

const Education = () => {
  return (
    <div>
      <Navbar />
      <EducationGreeting />
      <Footer />
    </div>
  );
};

export default Education;
